import { AeSidebarContent as AeSidebarItems, IAeSidebarProps, useEditorStore } from '@diana/core';
import { Stack } from '@mui/material';
import shallow from 'zustand/shallow';
import { useEffect } from 'react';
import { useAeLayoutSync } from './useAeAutoSelect';

export const AeSidebarContent = (props: Pick<IAeSidebarProps, 'keepItemsByType'>) => {
  const { keepItemsByType } = props;
  const aeNavigationItems = useEditorStore((store) => store.model?.items, shallow);
  const resetAeNav = useEditorStore((store) => store.resetAeNav);

  const { initialSetItemCallback, selectLayoutScope } = useAeLayoutSync(keepItemsByType);

  useEffect(() => {
    return () => resetAeNav();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Stack gap={0.25} pb={0.5} height="100%" sx={{ overflow: 'auto' }}>
      <AeSidebarItems
        items={aeNavigationItems}
        keepItemsByType={keepItemsByType}
        initialSetItemCallback={initialSetItemCallback}
        selectCallback={selectLayoutScope}
      />
    </Stack>
  );
};
